/* nt-quote-drawer.js — controls the global slide-in quote drawer (snippets/nt-quote-drawer-v1.liquid).
   Open it from anywhere with: <button data-nt-qd-open=" Channel Letters">Get a Quote</button>
   or programmatically: NT.openQuoteDrawer(' Channel Letters')
   Name, email, phone and logo are required — validated per-field, with a
   "normal" submit (logo upload + lead POST) and a "prospect" partial-save
   audit trail, both via window.NTQuoteAPI (assets/nt-quote-api.js).

   IMPORTANT: open/close must never depend on NTQuoteAPI. If nt-quote-api.js
   is slow/blocked/fails to load, every "Get a Quote" trigger on the site
   funnels through this file's click listener — a thrown error anywhere
   ahead of that binding would silently kill it site-wide. So the drawer's
   open/close mechanics are wired up first and unconditionally; everything
   that touches NTQuoteAPI (validation, uploads, prospect sync) is set up
   afterward, guarded so a missing/broken API degrades the form instead of
   breaking the drawer itself. */
window.NT = window.NT || {};

(function (NT) {
  document.addEventListener("DOMContentLoaded", function () {
    var backdrop = document.querySelector("[data-nt-qd-backdrop]");
    var drawer = document.querySelector("[data-nt-qd]");
    if (!backdrop || !drawer) return;

    var typeEl = drawer.querySelector("[data-nt-qd-type]");
    var typeDoneEl = drawer.querySelector("[data-nt-qd-type-done]");
    var formPanel = drawer.querySelector("[data-nt-qd-panel-form]");
    var donePanel = drawer.querySelector("[data-nt-qd-panel-done]");
    var form = drawer.querySelector("[data-nt-qd-form]");
    var errorEl = drawer.querySelector("[data-nt-qd-error]");
    var fileInput = drawer.querySelector("[data-nt-qd-file]");
    var fileWrap = drawer.querySelector("[data-nt-qd-file-wrap]");
    var fileLabel = drawer.querySelector("[data-nt-qd-file-label]");
    var fileHint = drawer.querySelector("[data-nt-qd-file-hint]");
    var fileList = drawer.querySelector("[data-nt-qd-file-list]");
    var fileClearBtn = drawer.querySelector("[data-nt-qd-file-clear]");
    var submitBtn = form ? form.querySelector('[type="submit"]') : null;
    var submitLabel = submitBtn ? submitBtn.textContent : "";
    var DEFAULT_FILE_LABEL = fileLabel ? fileLabel.textContent : "";
    var DEFAULT_FILE_HINT = fileHint ? fileHint.textContent : "";

    function escName(s) {
      return String(s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    function resetFieldState() {
      form.querySelectorAll(".has-error").forEach(function (el) {
        el.classList.remove("has-error");
      });
      form.querySelectorAll("[data-nt-qd-fielderr]").forEach(function (el) {
        el.hidden = true;
        el.textContent = "";
      });
    }

    // Main category the clicked sign type belongs to (actual name, set by the opener),
    // so the payload never depends on the ?cat= slug in the URL.
    var explicitCategory = "";

    function open(typeLabel, categoryName) {
      explicitCategory = categoryName || "";
      typeEl.textContent = typeLabel || "Sign";
      typeDoneEl.textContent = typeLabel || "Sign";
      formPanel.hidden = false;
      donePanel.hidden = true;
      form.reset();
      resetFieldState();
      if (fileLabel) fileLabel.textContent = DEFAULT_FILE_LABEL;
      if (fileWrap) fileWrap.classList.remove("has-file", "has-error");
      if (fileHint) fileHint.textContent = DEFAULT_FILE_HINT;
      if (fileList) fileList.innerHTML = "";
      if (fileClearBtn) fileClearBtn.hidden = true;
      errorEl.hidden = true;
      onOpen();
      backdrop.classList.add("is-on");
      drawer.classList.add("is-on");
      document.body.style.overflow = "hidden";
    }

    function close() {
      backdrop.classList.remove("is-on");
      drawer.classList.remove("is-on");
      document.body.style.overflow = "";
    }

    NT.openQuoteDrawer = open;
    NT.closeQuoteDrawer = close;

    function showThankYou() {
      try {
        var nameOut = drawer.querySelector("[data-nt-qd-name]");
        var emailOut = drawer.querySelector("[data-nt-qd-email]");
        var phoneOut = drawer.querySelector("[data-nt-qd-phone]");
        if (typeof fieldValue === "function") {
          var nameVal = fieldValue("name");
          var firstName = nameVal ? nameVal.split(/\s+/)[0] : "";
          if (nameOut) nameOut.textContent = firstName ? " " + firstName : "";
          if (emailOut) emailOut.textContent = fieldValue("email");
          if (phoneOut) phoneOut.textContent = fieldValue("phone");
        }
      } catch (e) { /* never let personalization break the thank-you screen */ }
      formPanel.hidden = true;
      donePanel.hidden = false;
      try {
        history.pushState(null, "", window.location.pathname + "?thanks-for-response");
      } catch (e) { }
    }

    // A failed submit must NOT show the same screen as a real success — that
    // hid the fact that no lead was ever sent (e.g. logo upload never
    // completed), so nobody noticed the lead was missing. Keep the form
    // visible and surface a real error instead.
    function showSubmitError(err, errorContext) {
      try {
        if (typeof window.logClientError === "function") {
          window.logClientError(
            errorContext || "nt_quote_drawer_v1_submit",
            err || new Error("form submit failed"),
            prospect ? prospect.uuid : null,
          );
        }
      } catch (e) { /* never let the logger break the caller */ }
      var msg = err && err.message === "Logo upload did not complete"
        ? "Your logo failed to upload, so we couldn’t send your request. Please retry the upload above and submit again."
        : "Something went wrong submitting your request. Please try again.";
      if (errorEl) {
        errorEl.textContent = msg;
        errorEl.hidden = false;
        errorEl.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      // Marks the failed attempt in the URL (distinct from a real
      // ?thanks-for-response) without navigating away from the form or
      // showing the success view — kept for reporting/analytics that
      // differentiate the two outcomes.
      try {
        history.pushState(null, "", window.location.pathname + "?thanks-for-submission");
      } catch (e) { }
    }

    // ── Core open/close mechanics — no NTQuoteAPI dependency, ever. ──
    document.addEventListener("click", function (e) {
      var opener = e.target.closest("[data-nt-qd-open]");
      if (opener) {
        e.preventDefault();
        open(opener.getAttribute("data-nt-qd-open"), opener.getAttribute("data-nt-qd-category"));
        return;
      }
      if (e.target.closest("[data-nt-qd-close]")) {
        close();
      }
    });
    backdrop.addEventListener("click", close);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-on")) close();
    });

    /* swipe-to-dismiss on mobile (bottom sheet) */
    var dragHandle = drawer.querySelector("[data-nt-qd-drag-handle]");
    if (dragHandle) {
      var startY = 0,
        dragging = false;
      dragHandle.addEventListener(
        "touchstart",
        function (e) {
          startY = e.touches[0].clientY;
          dragging = true;
        },
        { passive: true },
      );
      dragHandle.addEventListener(
        "touchmove",
        function (e) {
          if (!dragging) return;
          var dy = e.touches[0].clientY - startY;
          if (dy > 0) drawer.style.transform = "translateY(" + dy + "px)";
        },
        { passive: true },
      );
      dragHandle.addEventListener("touchend", function (e) {
        if (!dragging) return;
        dragging = false;
        var dy = e.changedTouches[0].clientY - startY;
        drawer.style.transform = "";
        if (dy > 90) close();
      });
    }

    // ── Everything below touches window.NTQuoteAPI. Wrapped so a missing
    // or broken API degrades the form (no validation/prospect/submit) but
    // never takes the open/close mechanics above down with it. ──
    var API = window.NTQuoteAPI;
    var prospect = null;
    var leadTracker = null;
    var fileManager = null;
    var onOpen = function () { };

    if (!API) {
      console.error(
        "nt-quote-drawer.js: window.NTQuoteAPI is unavailable — quote form validation/submit is disabled, but the drawer will still open.",
      );
      if (form) {
        form.addEventListener("submit", function (e) {
          e.preventDefault();
          errorEl.textContent =
            "This form is temporarily unavailable — please call us directly.";
          errorEl.hidden = false;
        });
      }
    } else {
      try {
        prospect = API.createProspectTracker();
        leadTracker = API.createLeadTracker(prospect.uuid);
        fileManager = API.createFileManager({
          name: function () {
            return fieldValue("name") || "lead";
          },
          uuid: prospect.uuid,
          onChange: renderFileList,
        });
        onOpen = function () {
          prospect = API.createProspectTracker();
          leadTracker = API.createLeadTracker(prospect.uuid);
          fileManager = API.createFileManager({
            name: function () {
              return fieldValue("name") || "lead";
            },
            uuid: prospect.uuid,
            onChange: renderFileList,
          });
        };

        var prospectTimer = null;

        // Spam gate helpers live in assets/spam-gate.js (window.SpamGate). It
        // owns window.leadFormState, the scroll listener, and the
        // 4-condition check. This drawer has no sign-type or indoor/outdoor
        // pickers to check (just name/phone/email/note/logo), so the two
        // picker-based conditions are neutralized with an always-checked
        // dummy checkbox — only scrollZero, fastFill and noAds are
        // meaningful signals here.
        var spamDummyId = "nt-qd-spam-dummy";
        var spamDummyCb = document.createElement("input");
        spamDummyCb.type = "checkbox";
        spamDummyCb.id = spamDummyId;
        spamDummyCb.checked = true;
        spamDummyCb.hidden = true;
        document.body.appendChild(spamDummyCb);

        var nameFieldEl = form.querySelector('[data-nt-qd-field="name"]');
        var emailFieldEl = form.querySelector('[data-nt-qd-field="email"]');
        if (nameFieldEl && !nameFieldEl.id) nameFieldEl.id = "nt-qd-spam-name";
        if (emailFieldEl && !emailFieldEl.id) emailFieldEl.id = "nt-qd-spam-email";

        var fieldValue = function (key) {
          var input = form.querySelector('[data-nt-qd-field="' + key + '"]');
          return input ? input.value.trim() : "";
        };

        // Main parent category (e.g. "Storefront Signs"): the category the clicked
        // sign type belongs to, then the category rendered on the page, and only
        // then the ?cat= slug of the sign-category page as a last resort.
        var currentCategoryName = function () {
          if (explicitCategory) return explicitCategory;
          if (window.NT && NT.currentSignCategory && NT.currentSignCategory.name) {
            return String(NT.currentSignCategory.name);
          }
          try {
            var slug = new URLSearchParams(window.location.search).get("cat");
            var cat = slug && window.NT && NT.SignCategories ? NT.SignCategories.get(slug) : null;
            return cat ? String(cat.name) : "";
          } catch (e) {
            return "";
          }
        };

        var buildBasePayload = function () {
          var noteEl = form.querySelector('[name="note"]');
          return {
            category: currentCategoryName(),
            name: fieldValue("name"),
            phone: fieldValue("phone"),
            email: fieldValue("email"),
            details: noteEl ? noteEl.value.trim() : "",
            signtypes: typeEl ? [typeEl.textContent.trim()] : [],
            lead_page_url: window.location.href,
            // Pages can override this via window.NTQuoteConfig.recordSource
            // (the portfolio page sets "Portfolio Page Categories").
            record_source: (window.NTQuoteConfig && NTQuoteConfig.recordSource) || "Collection Page Categories",
          };
        };

        var syncProspect = function () {
          var payload = buildBasePayload();
          payload.images = fileManager ? fileManager.urls() : [];
          prospect.sync(payload);
        };
        var scheduleProspectSync = function () {
          clearTimeout(prospectTimer);
          prospectTimer = setTimeout(syncProspect, 700);
        };

        var showFieldError = function (key, message) {
          var errEl = form.querySelector('[data-nt-qd-fielderr="' + key + '"]');
          var input = form.querySelector('[data-nt-qd-field="' + key + '"]');
          if (errEl) {
            errEl.textContent = message || "";
            errEl.hidden = !message;
          }
          if (input) input.classList.toggle("has-error", !!message);
        };

        var showFileError = function (message) {
          var errEl = form.querySelector('[data-nt-qd-fielderr="file"]');
          if (errEl) {
            errEl.textContent = message || "";
            errEl.hidden = !message;
          }
          if (fileWrap) fileWrap.classList.toggle("has-error", !!message);
        };

        ["name", "phone", "email"].forEach(function (key) {
          var input = form.querySelector('[data-nt-qd-field="' + key + '"]');
          if (!input) return;
          input.addEventListener("input", function () {
            if (key === "phone" && API.validators.formatPhone) {
              input.value = API.validators.formatPhone(input.value);
            }
            if (input.classList.contains("has-error"))
              showFieldError(key, API.validators.fieldError(key, input.value));
            scheduleProspectSync();
          });
          input.addEventListener("blur", function () {
            showFieldError(key, API.validators.fieldError(key, input.value));
            syncProspect();
          });
        });
        var noteField = form.querySelector('[name="note"]');
        if (noteField) noteField.addEventListener("blur", syncProspect);

        function renderFileList(files) {
          if (!fileInput) return;
          if (!files.length) {
            if (fileWrap) fileWrap.classList.remove("has-file");
            if (fileLabel) fileLabel.textContent = DEFAULT_FILE_LABEL;
            if (fileHint) {
              fileHint.classList.remove("err");
              fileHint.textContent = DEFAULT_FILE_HINT;
            }
            if (fileClearBtn) fileClearBtn.hidden = true;
            if (fileList) fileList.innerHTML = "";
            showFileError("");
            return;
          }

          if (fileWrap) fileWrap.classList.add("has-file");
          if (fileLabel)
            fileLabel.textContent =
              files.length === 1
                ? files[0].file.name
                : files.length + " files selected";
          if (fileClearBtn) fileClearBtn.hidden = false;

          var hint = API.fileHint(files);
          if (fileHint) {
            fileHint.classList.toggle("err", hint.isError);
            fileHint.textContent = hint.text || DEFAULT_FILE_HINT;
          }

          if (fileList) {
            fileList.innerHTML = files
              .map(function (entry) {
                var st = API.entryStatus(entry);
                var statusClass = st.cls;
                var statusText = escName(st.text);
                var retryBtn = st.canRetry
                  ? '<button type="button" class="nt-file-upload-item-retry" data-retry-id="' + entry.id + '">Retry</button>'
                  : "";
                return (
                  '<div class="nt-file-upload-item">' +
                  '<span class="nt-file-upload-item-name">' +
                  escName(entry.file.name) +
                  "</span>" +
                  '<span class="nt-file-upload-item-status ' +
                  statusClass +
                  '">' +
                  statusText +
                  "</span>" +
                  retryBtn +
                  '<button type="button" class="nt-file-upload-item-remove" data-remove-id="' +
                  entry.id +
                  '" aria-label="Remove file">' +
                  '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
                  "</button>" +
                  "</div>"
                );
              })
              .join("");
          }

          showFileError("");
          scheduleProspectSync();
        }

        if (fileInput) {
          // Clear before the picker opens so choosing the same file again still
          // fires "change". Uploads use their own in-memory copy of each file
          // (NTQuoteAPI.createFileManager), so nothing depends on this input's
          // file list after selection — never rewrite it mid-upload.
          fileInput.addEventListener("click", function () {
            fileInput.value = "";
          });
          fileInput.addEventListener("change", function () {
            if (fileInput.files && fileInput.files.length)
              fileManager.addFiles(fileInput.files);
          });
          ["dragover", "dragenter"].forEach(function (ev) {
            fileWrap.addEventListener(ev, function (e) {
              e.preventDefault();
              fileWrap.classList.add("drag");
            });
          });
          ["dragleave", "drop"].forEach(function (ev) {
            fileWrap.addEventListener(ev, function () {
              fileWrap.classList.remove("drag");
            });
          });
          fileWrap.addEventListener("drop", function (e) {
            e.preventDefault();
            if (
              e.dataTransfer &&
              e.dataTransfer.files &&
              e.dataTransfer.files.length
            )
              fileManager.addFiles(e.dataTransfer.files);
          });
        }

        if (fileList) {
          fileList.addEventListener("click", function (e) {
            var retryBtn = e.target.closest("[data-retry-id]");
            if (retryBtn) {
              fileManager.retry(retryBtn.getAttribute("data-retry-id"));
              return;
            }
            var removeBtn = e.target.closest("[data-remove-id]");
            if (removeBtn)
              fileManager.remove(removeBtn.getAttribute("data-remove-id"));
          });
        }

        if (fileClearBtn) {
          fileClearBtn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            fileManager.clear();
          });
        }

        if (form) {
          form.addEventListener("submit", function (e) {
            e.preventDefault();
            errorEl.hidden = true;

            var firstInvalid = null;
            ["name", "phone", "email"].forEach(function (key) {
              var input = form.querySelector(
                '[data-nt-qd-field="' + key + '"]',
              );
              var msg = API.validators.fieldError(key, input.value);
              showFieldError(key, msg);
              if (msg && !firstInvalid) firstInvalid = input;
            });

            var fileMsg =
              fileManager.hasLogo() || fileManager.isUploading()
                ? ""
                : "Please upload your logo so we can build your mockup.";
            showFileError(fileMsg);
            if (fileMsg && !firstInvalid) firstInvalid = fileInput;

            if (firstInvalid) {
              firstInvalid.focus();
              return;
            }

            var evaluation = window.SpamGate && window.SpamGate.evaluateSpam({
              signTypeSelector: "#" + spamDummyId,
              placementIds: [spamDummyId],
            });

            if (evaluation && evaluation.isSpam) {
              if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = "Sending…";
              }
              window.SpamGate.submitFormB(form, {
                spamReason: "ntqd1",
                emailFieldId: emailFieldEl ? emailFieldEl.id : "email",
                nameFieldId: nameFieldEl ? nameFieldEl.id : "name",
                onDone: function () {
                  showThankYou();
                  if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = submitLabel;
                  }
                },
              });
              return;
            }
            if (evaluation) window.SpamGate.attachDiagnosticMeta(form, evaluation, "ntqd1");
            // Mark end of this fill cycle so the next submit's elapsedMs is measured
            // from now, not from page load. Only formOpenedAt is reset; maxScroll persists.
            if (window.SpamGate) window.SpamGate.resetLeadFormState();

            if (submitBtn) {
              submitBtn.disabled = true;
              submitBtn.textContent = "Sending…";
            }

            // Fire the lead submit as soon as the logo upload is done — don't
            // gate it behind the prospect audit-trail chain (getChain()),
            // which can still have pending debounced autosave requests in
            // flight and would otherwise make /api/leads visibly wait behind
            // those in the network tab.
            fileManager.waitForUploads()
              .then(function () {
                if (!fileManager.hasLogo())
                  throw new Error("Logo upload did not complete");
                var payload = buildBasePayload();
                Object.assign(payload, fileManager.leadImageFields());
                return leadTracker.submit(payload);
              })
              .then(function (data) {
                if (prospect) prospect.finalize();
                showThankYou();
                var emailVal = fieldValue("email");
                // /api/leads (nt-quote-api.js) doesn't compute geo-IP server-side like
                // the legacy /api/no-approval endpoint did — it just echoes back
                // whatever `location` string the client sent. That string is set
                // client-side in layout/theme.liquid as "city, region, country,
                // timezone, ip" (ip last) and is already in localStorage before
                // submit — read it from there.
                try {
                  var location = (window.safeLocalStorage || localStorage).getItem("location") || (window.safeLocalStorage || localStorage).getItem("locationxh") || "";
                  var locationParts = location ? location.split(", ") : [];
                  var ipAddress = locationParts.length ? locationParts[locationParts.length - 1] : "";
                  var spamIp = !!(ipAddress && (ipAddress.indexOf("2603:7000:b040:1ea1:") !== -1 || ipAddress.indexOf("174.255.203") !== -1));
                  var spamEmail = !!(emailVal && emailVal.toLowerCase().indexOf("fastsigns") !== -1);
                  if (!spamIp && !spamEmail) {
                    if (typeof gtag_report_conversion === 'function') gtag_report_conversion();
                  } else {
                    console.log("gtag_report_conversion skipped for flagged lead:", { ipAddress: ipAddress, email: emailVal, spamIp: spamIp, spamEmail: spamEmail });
                  }
                } catch (error) {
                  console.error('Error during gtag_report_conversion:', error);
                }
                try {
                  if (typeof bingTagFunction === "function") bingTagFunction(window, document, "script", "//bat.bing.com/bat.js", "uetq");
                } catch (e) {
                  console.error("bingTagFunction error:", e);
                }
                try {
                  if (typeof kalviyo === "function") kalviyo(emailVal);
                } catch (e) {
                  console.error("kalviyo error:", e);
                }
                // /api/leads returns { data: { is_spam }, airtableRecordId } — the
                // lead's own Airtable record id, not the old
                // { airtable_data: { body: { records }}} shape.
                try {
                  var leadRecord = (data && data.data) || {};
                  if (!leadRecord.is_spam && data && data.airtableRecordId && typeof checkisDuplicate === "function") {
                    checkisDuplicate(data.airtableRecordId, emailVal, fieldValue("name"), "SignMakerz", fieldValue("phone"));
                  }
                } catch (e) {
                  console.error("checkisDuplicate error:", e);
                }
              })
              .catch(function (err) {
                showSubmitError(err, "nt_quote_drawer_v1_submit");
              })
              .finally(function () {
                if (submitBtn) {
                  submitBtn.disabled = false;
                  submitBtn.textContent = submitLabel;
                }
              });
          });
        }

        document.addEventListener("visibilitychange", function () {
          if (document.hidden && drawer.classList.contains("is-on"))
            syncProspect();
        });
        window.addEventListener("pagehide", function () {
          if (drawer.classList.contains("is-on")) syncProspect();
        });
      } catch (err) {
        console.error(
          "nt-quote-drawer.js: form behavior failed to initialize, drawer open/close still works.",
          err,
        );
      }
    }
  });
})(window.NT);
